import { Reducer } from "redux";
import { TableTypes } from "utilities/interfaces/ITable";
import { TableActions } from "./tableActions";
import tableTypes from "./tableTypes";

const INITIAL_STATE = {
  filters: {},
  data: {},
  filterTags: {},
};

const tableReducer: Reducer<TableTypes, TableActions> = (
  state: TableTypes = { ...INITIAL_STATE },
  action
) => {
  switch (action.type) {
    case tableTypes.Initial_Filter:
      return {
        ...state,
        filters: { ...action.payload },
      };
    case tableTypes.Clear_Filter:
      return {
        ...state,
        filters: {},
        filterTags: {},
      };
    case tableTypes.Initial_Table:
      return {
        ...action.payload,
      };
    case tableTypes.Handle_Filter:
      const tempFilters = { ...state.filters };
      tempFilters[action.payload.name] = action.payload.data;
      return {
        ...state,
        filters: { ...tempFilters },
      };
    case tableTypes.Change_Filter:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };
    case tableTypes.Handle_FilterTags:
      const tempFilterTags = { ...state.filterTags };
      tempFilterTags[action.payload.name] = action.payload.data;
      return {
        ...state,
        filterTags: { ...tempFilterTags },
      };
    case tableTypes.Clear_FilterTags:
      const filterTagsTemp = { ...state.filterTags };
      const filtersTemp = { ...state.filters };
      filtersTemp[action.payload.name] = null;
      delete filterTagsTemp[action.payload.name];
      return {
        ...state,
        filterTags: { ...filterTagsTemp },
        filters: { ...filtersTemp },
      };
    default:
      return state;
  }
};

export default tableReducer;
